import React from 'react';
import PropTypes from 'prop-types';
import Text from 'components/text/text';

class ProductGenderToggle extends React.Component {
  constructor(props) {
    super(props);

    this.state = { 'isToggled': this.props.isToggled };

    this.setupHandlers();
  }

  /**
   * React Lifecycle Hook
   * Invoked before a mounted component receives new props. If you need to
   * update the state in response to prop changes, you may compare this.props
   * and nextProps and perform state transitions
   *
   * @method  componentWillReceiveProps
   */
  componentWillReceiveProps(nextProps) {
    if (nextProps.isToggled !== this.props.isToggled) {
      this.setState({ 'isToggled': nextProps.isToggled });
    }
  }

  /**
   * Binds any handlers to the correct context
   *
   * @method  setUpHandlers
   */
  setupHandlers() {
    this.onClick = this.handleClick.bind(this);
  }

  /**
   * Handles toggle click. Fires callback if supplied otherwise toggles
   * internal state
   *
   * @method handleClick
   * @param  {[type]} event [The generated click event]
   */
  handleClick(event) {
    event.preventDefault();

    const { onToggle } = this.props;

    if (onToggle) {
      this.props.onToggle(!this.state.isToggled);
    } else {
      this.setState({ 'isToggled': !this.state.isToggled });
    }
  }

  render() {
    const { onText, offText } = this.props;
    const text = this.state.isToggled ? offText : onText;

    return(
      <button type="button" onClick={this.onClick}>
        <Text
          className="mix-txt_uppercase"
          color="DefaultBlue"
          weight="light"
        >
          {text}
        </Text>
      </button>
    )
  }
}

ProductGenderToggle.propTypes = {
  isToggled: PropTypes.bool,
  offText: PropTypes.string.isRequired,
  onText: PropTypes.string.isRequired,
  onToggle: PropTypes.func
};

ProductGenderToggle.defaultProps = {
  isToggled: false
};

export default ProductGenderToggle;



// WEBPACK FOOTER //
// ./src/client/pages/product-matches/_product-gender-toggle.jsx